export const GUEST_CLAIM_ERROR_CODES = {
  missingToken: "MISSING_CLAIM_TOKEN",
  invalidToken: "CLAIM_NOT_FOUND",
  accountConflict: "CLAIM_ACCOUNT_CONFLICT",
  authentication: "AUTH_REQUIRED",
  temporary: "CLAIM_TEMPORARY_FAILURE",
} as const;

export type GuestClaimErrorKind =
  | "account_conflict"
  | "invalid"
  | "authentication"
  | "temporary";

function readErrorCode(payload: unknown): string | null {
  if (
    typeof payload === "object" &&
    payload !== null &&
    "code" in payload &&
    typeof payload.code === "string"
  ) {
    return payload.code;
  }
  return null;
}

export function resolveGuestClaimErrorKind(
  status: number,
  payload: unknown,
): GuestClaimErrorKind {
  const code = readErrorCode(payload);
  if (status === 409 || code === GUEST_CLAIM_ERROR_CODES.accountConflict) {
    return "account_conflict";
  }
  if (
    status === 400 ||
    status === 404 ||
    code === GUEST_CLAIM_ERROR_CODES.missingToken ||
    code === GUEST_CLAIM_ERROR_CODES.invalidToken
  ) {
    return "invalid";
  }
  if (status === 401 || code === GUEST_CLAIM_ERROR_CODES.authentication) {
    return "authentication";
  }
  return "temporary";
}
